import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import "./styles/app.css";

/**
 * One query client for the app.
 *
 * `retry: 1` on reads is a walk-in-cooler concession — one retry absorbs a single
 * dropped packet without turning a real outage into a long spinner. **Mutations
 * default to no retries at all**, which is the ground the never-retry-a-post rule
 * (§ 4.5) is built on: that rule then needs no exception, only confirmation.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
